import { ITypedReduxAction } from '../../types/redux/actionType';

export enum EMessagesActionTypes {
  LoadingUnreadMessages = 'messages/loading-unread-messages',
  LoadedUnreadMessages = 'messages/loaded-unread-messages',
  FailedUnreadMessages = 'messages/failed-unread-messages',
  ResetUnreadMessages = 'messages/reset-unread-messages',
  UpdateCount = 'messages/update-count',
}

export interface IUnreadMessagesRequestPayload {
  requestId: number;
}

export interface ILoadedUnreadMessagesPayload extends IUnreadMessagesRequestPayload {
  count: number;
}

export type TLoadingUnreadMessages = ITypedReduxAction<
  EMessagesActionTypes.LoadingUnreadMessages,
  IUnreadMessagesRequestPayload
>;
export type TLoadedUnreadMessages = ITypedReduxAction<
  EMessagesActionTypes.LoadedUnreadMessages,
  ILoadedUnreadMessagesPayload
>;
export type TFailedUnreadMessages = ITypedReduxAction<
  EMessagesActionTypes.FailedUnreadMessages,
  IUnreadMessagesRequestPayload
>;
export type TResetUnreadMessages = ITypedReduxAction<EMessagesActionTypes.ResetUnreadMessages>;
export type TUpdateMessagesCount = ITypedReduxAction<EMessagesActionTypes.UpdateCount, number>;

export type TMessagesActions =
  | TLoadingUnreadMessages
  | TLoadedUnreadMessages
  | TFailedUnreadMessages
  | TResetUnreadMessages
  | TUpdateMessagesCount;
